import React from 'react'
import { Box, CircularProgress } from '@mui/material'

export default function LoadingComponent(props) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 240,
                width: '100%',
                ...props.style,
                ...props.styles,   // keep legacy prop name too
            }}
        >
            <CircularProgress color='success' thickness={3} size={40} />
        </Box>
    )
}
